import { Component, OnInit } from '@angular/core';
import { FoodUnitRatioModel } from 'src/app/core/model/object/diet-food-model';
import { PlanService } from 'src/app/data/repository/plan-repository/plan.service';
import { PlanShared } from '../../general/shared/plan-shared';
import { FoodLogModel } from 'src/app/core/model/object/foodlog-model';
import { CalorieCalculator } from 'src/app/utils/calorie-calculator';

@Component({
  selector: 'app-daily-food-fact',
  templateUrl: './daily-food-fact.component.html',
  styleUrls: ['./daily-food-fact.component.scss'],
})
export class DailyFoodFactComponent implements OnInit {
  foodFactsNames = [];
  foodFactsUnits = [];
  foodFactsAmount = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  dataIsReady = false;

  constructor(
    private planService: PlanService,
    private planShared: PlanShared,
    private calorieCalculator: CalorieCalculator
  ) {
    this.prepare();
  }

  ngOnInit() {}

  back() {
    this.planService.goBack();
  }

  prepare() {
    this.foodFactsAmount = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    this.foodFactsNames = [];
    this.foodFactsUnits = [];

    if (!this.planShared.selectedDietDayFoodLogs) {
      this.back();
      return;
    }

    let hasFoodLog = false;
    this.planShared.selectedDietDayFoodLogs.foodLogs.forEach((foodlog) => {
      hasFoodLog = true;
      const ratio = this.calorieCalculator.findFoodLogRatio(foodlog);
      this.foodFactsAmount = this.prepareFoodFactsAmounts(
        foodlog,
        this.foodFactsAmount,
        ratio
      );
      this.foodFactsNames = this.prepareFoodFactsPersianNames(foodlog);
      this.foodFactsUnits = this.prepareFoodFactsPersianUnits(foodlog);
    });

    if (!hasFoodLog) {
      this.foodFactsAmount = [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ];
      this.foodFactsNames = [
        'کالری',
        'پروتئین',
        'کربوهیدرات',
        'چربی',
        'قند',
        'فیبر',
        'سدیم',
        'پتاسیم',
        'کلسیم',
        'منیزیم',
        'فسفر',
        'آهن',
        'اسید چرب اشباع',
        'اسید های چرب تک غیر اشباع',
        'اسیدهای چرب چند غیر اشباع',
        'اسید چرب ترانس',
        'کلسترول',
      ];
      this.foodFactsUnits = [
        'کالری',
        'گرم',
        'گرم',
        'گرم',
        'گرم',
        'گرم',
        'میلی گرم',
        'میلی گرم',
        'میلی گرم',
        'میلی گرم',
        'میلی گرم',
        'میلی گرم',
        'گرم',
        'گرم',
        'گرم',
        'گرم',
        'میلی گرم',
      ];
    }
    this.dataIsReady = true;
  }

  prepareFoodFactsAmounts(
    food: FoodLogModel,
    foodFactsAmount: number[],
    ratio: FoodUnitRatioModel
  ): number[] {
    if (food.calorie && food.title) {
      foodFactsAmount[0] = food.calorie;
    } else {
      foodFactsAmount[0] =
        food.foodModel.foodFactModel.calorie.amount !== -1 &&
        this.foodFactsAmount[0] !== -1
          ? ((food.foodModel.foodFactModel.calorie.amount * food.amount) /
              100) *
              ratio.ratio +
            foodFactsAmount[0]
          : -1;
    }
    foodFactsAmount[1] =
      food.foodModel.foodFactModel.protein.amount !== -1 &&
      this.foodFactsAmount[1] !== -1
        ? ((food.foodModel.foodFactModel.protein.amount * food.amount) / 100) *
            ratio.ratio +
          foodFactsAmount[1]
        : -1;
    foodFactsAmount[2] =
      food.foodModel.foodFactModel.carbohydrate.amount !== -1 &&
      this.foodFactsAmount[2] !== -1
        ? ((food.foodModel.foodFactModel.carbohydrate.amount * food.amount) /
            100) *
            ratio.ratio +
          foodFactsAmount[2]
        : -1;
    foodFactsAmount[3] =
      food.foodModel.foodFactModel.fat.amount !== -1 &&
      this.foodFactsAmount[3] !== -1
        ? ((food.foodModel.foodFactModel.fat.amount * food.amount) / 100) *
            ratio.ratio +
          foodFactsAmount[3]
        : -1;
    foodFactsAmount[4] =
      food.foodModel.foodFactModel.sugar.amount !== -1 &&
      this.foodFactsAmount[4] !== -1
        ? ((food.foodModel.foodFactModel.sugar.amount * food.amount) / 100) *
            ratio.ratio +
          foodFactsAmount[4]
        : -1;
    foodFactsAmount[5] =
      food.foodModel.foodFactModel.fiber.amount !== -1 &&
      this.foodFactsAmount[5] !== -1
        ? ((food.foodModel.foodFactModel.fiber.amount * food.amount) / 100) *
            ratio.ratio +
          foodFactsAmount[5]
        : -1;
    foodFactsAmount[6] =
      food.foodModel.foodFactModel.sodium.amount !== -1 &&
      this.foodFactsAmount[6] !== -1
        ? ((food.foodModel.foodFactModel.sodium.amount * food.amount) / 100) *
            ratio.ratio +
          foodFactsAmount[6]
        : -1;
    foodFactsAmount[7] =
      food.foodModel.foodFactModel.potassium.amount !== -1 &&
      this.foodFactsAmount[7] !== -1
        ? ((food.foodModel.foodFactModel.potassium.amount * food.amount) /
            100) *
            ratio.ratio +
          foodFactsAmount[7]
        : -1;
    foodFactsAmount[8] =
      food.foodModel.foodFactModel.calcium.amount !== -1 &&
      this.foodFactsAmount[8] !== -1
        ? ((food.foodModel.foodFactModel.potassium.amount * food.amount) /
            100) *
            ratio.ratio +
          foodFactsAmount[8]
        : -1;
    foodFactsAmount[9] =
      food.foodModel.foodFactModel.magnesium.amount !== -1 &&
      this.foodFactsAmount[9] !== -1
        ? ((food.foodModel.foodFactModel.magnesium.amount * food.amount) /
            100) *
            ratio.ratio +
          foodFactsAmount[9]
        : -1;
    foodFactsAmount[10] =
      food.foodModel.foodFactModel.phosphor.amount !== -1 &&
      this.foodFactsAmount[10] !== -1
        ? ((food.foodModel.foodFactModel.phosphor.amount * food.amount) / 100) *
            ratio.ratio +
          foodFactsAmount[10]
        : -1;
    foodFactsAmount[11] =
      food.foodModel.foodFactModel.iron.amount !== -1 &&
      this.foodFactsAmount[11] !== -1
        ? ((food.foodModel.foodFactModel.iron.amount * food.amount) / 100) *
            ratio.ratio +
          foodFactsAmount[11]
        : -1;
    foodFactsAmount[12] =
      food.foodModel.foodFactModel.saturatedFat.amount !== -1 &&
      this.foodFactsAmount[12] !== -1
        ? ((food.foodModel.foodFactModel.saturatedFat.amount * food.amount) /
            100) *
            ratio.ratio +
          foodFactsAmount[12]
        : -1;
    foodFactsAmount[13] =
      food.foodModel.foodFactModel.monounsaturatedFat.amount !== -1 &&
      this.foodFactsAmount[13] !== -1
        ? ((food.foodModel.foodFactModel.monounsaturatedFat.amount *
            food.amount) /
            100) *
            ratio.ratio +
          foodFactsAmount[13]
        : -1;
    foodFactsAmount[14] =
      food.foodModel.foodFactModel.polyunsaturatedFat.amount !== -1 &&
      this.foodFactsAmount[14] !== -1
        ? ((food.foodModel.foodFactModel.polyunsaturatedFat.amount *
            food.amount) /
            100) *
            ratio.ratio +
          foodFactsAmount[14]
        : -1;
    foodFactsAmount[15] =
      food.foodModel.foodFactModel.transFat.amount !== -1 &&
      this.foodFactsAmount[15] !== -1
        ? ((food.foodModel.foodFactModel.transFat.amount * food.amount) / 100) *
            ratio.ratio +
          foodFactsAmount[15]
        : -1;
    foodFactsAmount[16] =
      food.foodModel.foodFactModel.cholesterol.amount !== -1 &&
      this.foodFactsAmount[16] !== -1
        ? ((food.foodModel.foodFactModel.cholesterol.amount * food.amount) /
            100) *
            ratio.ratio +
          foodFactsAmount[16]
        : -1;
    return foodFactsAmount;
  }

  prepareFoodFactsPersianNames(food: FoodLogModel): string[] {
    return [
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.calorie.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.protein.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.carbohydrate.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.fat.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.sugar.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.fiber.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.sodium.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.potassium.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.calcium.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.magnesium.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.phosphor.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.iron.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.saturatedFat.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.monounsaturatedFat.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.polyunsaturatedFat.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.transFat.name
      ),
      this.planService.getFoodFactPersianName(
        food.foodModel.foodFactModel.cholesterol.name
      ),
    ];
  }

  prepareFoodFactsPersianUnits(food: FoodLogModel): string[] {
    return [
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.calorie.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.protein.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.carbohydrate.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.fat.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.sugar.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.fiber.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.sodium.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.potassium.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.calcium.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.magnesium.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.phosphor.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.iron.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.saturatedFat.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.monounsaturatedFat.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.polyunsaturatedFat.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.transFat.name
      ),
      this.planService.getFoodFactPersianUnit(
        food.foodModel.foodFactModel.cholesterol.name
      ),
    ];
  }
}
